<template>
  <div id="app">
   <div class="progress-bg" v-if="showStep">
    <div class="progress" :style="{ width : progress + '%'}"> </div>
    </div>
  <components :is="currentView" transition="slid"> </components>
  </div>
</template>

<script>
export default {
  props: ['currentView', 'step'],
  computed: {
    showStep () {
      return this.currentView !== 'result' && this.currentView !== 'cover'
    },
    progress () {
      return this.step / 10 * 100
    }
  }
}
</script>

<style>

body{
  background: #f6f6f6;
  margin: 0;
  padding: 0;
  font-family: "Helvetica Neue","Microsoft Yahei",Helvetica,STHeiTi,sans-serif;
  overflow: hidden;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
#app{
  width: 100%;
}
.progress-bg{
  position: absolute;
  height: 3px;
  background: #cacacc;
  width: 100%;
}
.progress{
  height: 3px;
  background: #d94b40;
}
.slid-transition {
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  overflow: hidden;
  position: absolute;
  width: 100%;
  -webkit-backface-visibility: hidden;
}
.slid-enter{
  -webkit-transform: translateX(100%);
    transform: translateX(100%);
}
.slid-leave{
  -webkit-transform: translateX(-100%);
    transform: translateX(-100%);
} 
</style>



/** WEBPACK FOOTER **
 ** App.vue?3fae1c06
 **/